const UTILS = {
  ConvertStringToJS(str) {
    var script = document.createElement("script");
    script.text = str;
    document.head.appendChild(script).parentNode.removeChild(script);
  },
  ConvertStringToHTML(str) {
    let parser = new DOMParser();
    let doc = parser.parseFromString(str, "text/html");
    return doc.body;
  },
  Handleize(text) {
    return text
      .toString()
      .toLowerCase()
      .replace(/\s+/g, "-") // Replace spaces with -
      .replace(/[^\w\-]+/g, "") // Remove all non-word chars
      .replace(/\-\-+/g, "-") // Replace multiple - with single -
      .replace(/^-+/, "") // Trim - from start of text
      .replace(/-+$/, ""); // Trim - from end of text
  },
};

RebuyWidgetProducts = (() => {
  const REBUY_WIDGET_ID = "84124";
  const OnRebuyWidgetLoad = (REBUY_WIDGET_ID, callback) => {
    var loaded = false;
    var timer = setInterval(function () {
      if (window.Rebuy && window.Rebuy.widgets && window.Rebuy.widgets.length) {
        const REBUY_WIDGET = Rebuy.widgets.find(
          (widget) => widget.id == REBUY_WIDGET_ID
        );
        if (
          REBUY_WIDGET &&
          REBUY_WIDGET.data &&
          REBUY_WIDGET.data.products &&
          REBUY_WIDGET.data.products.length
        ) {
          loaded = true;
          clearInterval(timer);
          callback(REBUY_WIDGET);
        }
      }
    }, 250);
  };

  return () => {
    return {
      products: [],

      bundle_price() {
        let inst = this;
        let selected_products = inst.products.filter((p) => p.selected);
        let total = selected_products.reduce((sum, p) => {
          // return sum + parseFloat(p.selected_variant.price);
          var variantId = p.selected_variant.id;
          var igPrice =
            window.igData?.price.getPriceByVariantId(variantId) ||
            p.selected_variant.price;
          return sum + parseFloat(igPrice);
        }, 0);
        let total_formatted = theme.Currency.formatMoney(total * 100).replace(
          ".00",
          ""
        );

        let total_compare = inst.products.reduce((sum, p) => {
          let compare_price = parseFloat(
            // p.selected_variant.compare_at_price || p.selected_variant.price
            window.igData?.price.getComparePriceByVariantId(
              p.selected_variant.id
            ) ||
              p.selected_variant.compare_at_price ||
              p.selected_variant.price
          );
          return sum + compare_price;
        }, 0);
        let total_compare_formatted = theme.Currency.formatMoney(
          total_compare * 100
        ).replace(".00", "");

        return {
          total,
          total_compare,
          total_formatted,
          total_compare_formatted,
        };
      },

      toggle_tab: false,

      init() {
        let inst = this;
        OnRebuyWidgetLoad(REBUY_WIDGET_ID, (REBUY_WIDGET) => {
          inst.widget = REBUY_WIDGET;
          inst.products = [...REBUY_WIDGET.data.products];
          inst.ShowWidget();
        });
      },

      ShowWidget() {
        document
          .querySelector(`#rebuy-bundle-${REBUY_WIDGET_ID}`)
          .classList.remove("tw-hidden");
      },

      GetSelectedVariantImage(product) {
        let image = product.images.find(
          (img) => img.id == product.selected_variant.image_id
        );
        if (!image) {
          image = product.images[0];
        }
        return image;
      },

      AddBundleToCart(e) {
        let $rebuy_widget_original = document.querySelector(
          `[data-rebuy-id="${REBUY_WIDGET_ID}"]`
        );
        if (!$rebuy_widget_original) return;

        let $rebuy_btn_atc = $rebuy_widget_original.querySelector(
          ".rebuy-bundle__actions-buttons button"
        );
        if (!$rebuy_btn_atc) return;

        $rebuy_btn_atc.dispatchEvent(new Event("click", { bubbles: true }));
      },
    };
  };
})();

document.addEventListener("alpine:init", () => {
  Alpine.data("VariantSwatches", () => ({
    $section: null,
    $form: null,
    init() {
      let am = this;
      document.addEventListener("init-variant-swatches", (e) => {
        let $target = e.target;
        am.$target = $target;
        am.$form = $target.closest(".product-form");
      });
    },
    SelectVariant(e) {
      let am = this;
      let options = JSON.parse(e.target.dataset.options);
      if (am.$form) {
        am.$form
          .querySelectorAll(".selector-wrapper")
          .forEach(($item, index) => {
            let $option = $item.querySelector(".single-option-selector");
            if (!$option) return;

            if (options[index]) {
              $option.value = options[index];
            }
            $option.dispatchEvent(new CustomEvent("change", { bubbles: true }));
          });
      }

      // update sticky bar price
      let variant_id = e.target.value;
      (async () => {
        let variant_res = await fetch(
          `${window.location.pathname}?variant=${variant_id}&sections=product-template-concentrate`
        ).then((res) => res.json());
        let $html = UTILS.ConvertStringToHTML(
          variant_res["product-template-concentrate"]
        );
        let $stickyATC_price = $html.querySelector(
          ".sticky-atc--container [data-price]"
        );
        document.querySelector(
          ".sticky-atc--container [data-price]"
        ).innerHTML = $stickyATC_price.innerHTML;
      })();
    },
    SelectVariant64oz(e) {
      let am = this;
      console.log({ am });
      console.log("e.tartget", e.target);
      let options = JSON.parse(e.target.dataset.options);
      if (am.$form) {
        am.$form
          .querySelectorAll(".selector-wrapper")
          .forEach(($item, index) => {
            let $option = $item.querySelector(".single-option-selector");
            if (!$option) return;

            if (options[index]) {
              $option.value = options[index];
            }
            $option.dispatchEvent(new CustomEvent("change", { bubbles: true }));
          });
      }

      // update sticky bar price
      const variant_id = document.getElementById(
        "ProductSelect-product-template-concentrate-64oz"
      ).value;

      (async () => {
        let variant_res = await fetch(
          `${window.location.pathname}?variant=${variant_id}&sections=product-template-concentrate`
        ).then((res) => res.json());
        let $html = UTILS.ConvertStringToHTML(
          variant_res["product-template-concentrate"]
        );
        let $stickyATC_price = $html.querySelector(
          ".sticky-atc--container [data-price]"
        );
        document.querySelector(
          ".sticky-atc--container [data-price]"
        ).innerHTML = $stickyATC_price.innerHTML;
      })();

      const params = new URLSearchParams(window.location.search);
      const variant = parseInt(params.get("variant"));
      const quantitySelector = document.querySelector(
        ".product-form__controls-group.product-form__controls-group--submit .product-form-qty"
      );

      if (variant === 44825722224864 || variant === 44825727598816) {
        quantitySelector.dataset.max = 2;
      } else {
        quantitySelector.dataset.max = 1;
      }
    },
  }));

  Alpine.data("ProductImages", () => ({
    $slick: null,
    $thumbsWrapper: null,
    $thumbs: null,
    $btnPrev: null,
    $btnNext: null,
    init() {
      document.addEventListener("init:ProductImages", (e) => {
        let am = this;
        let $target = e.target;
        this.$slick = $target.querySelector(".js-slick-product");
        this.$thumbsWrapper = $target.querySelector(".product-images-thumbs");
        this.$thumbs = $target.querySelectorAll(
          ".product-images-thumbs .thumb"
        );
        this.$btnPrev = $target.querySelector(
          ".product-images-thumbs_btn-prev"
        );
        this.$btnNext = $target.querySelector(
          ".product-images-thumbs_btn-next"
        );

        $(this.$thumbs).on("click", "*", function (e) {
          let thumb = e.target.closest(".thumb");
          if (thumb) {
            for (let i = 0; i < am.$thumbs.length; i++) {
              am.$thumbs[i].classList.remove("active");
            }

            let index = parseInt(thumb.dataset.index);
            $(am.$slick).slick("slickGoTo", index);
            thumb.classList.add("active");
          }
        });

        $(this.$btnPrev).on("click", function () {
          let activeThumb = am.$thumbsWrapper.querySelector(".thumb.active");
          let goToIndex = parseInt(activeThumb.dataset.index) - 1;
          if (goToIndex < 0) {
            goToIndex = am.$thumbs.length - 1;
          }
          for (let i = 0; i < am.$thumbs.length; i++) {
            am.$thumbs[i].classList.remove("active");
          }
          $(am.$slick).slick("slickGoTo", goToIndex);
        });
        $(this.$btnNext).on("click", function () {
          let activeThumb = am.$thumbsWrapper.querySelector(".thumb.active");
          let goToIndex = parseInt(activeThumb.dataset.index) + 1;
          if (goToIndex > am.$thumbs.length - 1) {
            goToIndex = 0;
          }
          for (let i = 0; i < am.$thumbs.length; i++) {
            am.$thumbs[i].classList.remove("active");
          }
          $(am.$slick).slick("slickGoTo", goToIndex);
        });

        this.initCarousel();
      });
    },
    initCarousel() {
      $(this.$slick).not(".slick-initialized").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
      });
      $(this.$slick).on("afterChange", (_e, slick) => {
        let index = slick.currentSlide;
        for (let i = 0; i < this.$thumbs.length; i++) {
          this.$thumbs[i].classList.remove("active");
        }
        this.$thumbs[index].classList.add("active");
        this.$thumbsWrapper.scrollLeft = this.$thumbs[index].offsetLeft;
      });
    },
  }));

  // Alpine.data("ProductImagesThumbs", () => ({
  //   $thumbs: null,
  //   init() {
  //     document.addEventListener("init:ProductImagesThumbs", (e) => {
  //       let $target = e.target;
  //       this.$thumbs = $target.querySelectorAll(".product-images-thumbs img");
  //       console.log("INIT thumbs", this.$thumbs);

  //       $(".product-images-thumbs").on("click", "*", this.thumbClickHandler);
  //     });
  //   },
  //   thumbClickHandler(e) {
  //     console.log("event target", e.target);
  //     let thumb = e.target.closest(".thumb");
  //     if (thumb) {
  //       console.log("found thumb", thumb);
  //       let index = parseInt(thumb.dataset.index);
  //       $(am.$slick).slick("slickGoTo", index);
  //     }
  //   },
  //   // initCarousel() {
  //   // $(this.$slick).slick({
  //   // slidesToShow: 4,
  //   // slidesToScroll: 1,
  //   // asNavFor: ".product-images .js-slick-product",
  //   // focusOnSelect: false,
  //   // arrows: false,
  //   // mobileFirst: true,
  //   // infinite: false,
  //   // swipeToSlide: false,
  //   // adaptiveHeight: true,
  //   // draggable: false,
  //   // responsive: [
  //   //   {
  //   //     breakpoint: 750,
  //   //     settings: {
  //   //       slidesToShow: 4,
  //   //     },
  //   //   },
  //   //   {
  //   //     breakpoint: 1024,
  //   //     settings: {
  //   //       slidesToShow: 5,
  //   //     },
  //   //   },
  //   //   {
  //   //     breakpoint: 1400,
  //   //     settings: {
  //   //       slidesToShow: 5,
  //   //     },
  //   //   },
  //   // ],
  //   // });
  //   // $(this.$slick).on("afterChange", (_e, slick) => {
  //   //   $(this.$slick).find(".thumb.active").removeClass("active");
  //   //   $(this.$slick)
  //   //     .find(`.thumb[data-index=${slick.currentSlide}]`)
  //   //     .addClass("active");
  //   // });
  //   // },
  // }));

  Alpine.data("CustomScrollColumns", () => ({
    $target: null,
    $scrollTarget: null,
    scrollProgress: 0,
    showScrollProgress: false,
    SetTarget(id) {
      let $target = document.getElementById(id);
      if (!$target) return;
      this.$target = $target;
    },
    init() {
      let am = this;

      document.addEventListener("init:CustomScrollColumns", (e) => {
        let $target = e.target;
        am.$target = $target;
        am.$scrollTarget = $target.querySelector(".section-wrap");

        am.UpdateScrollProgress();
        window.addEventListener("resize", () => {
          setTimeout(am.UpdateScrollProgress.bind(am), 0);
        });
      });
    },
    UpdateScrollProgress(e) {
      let am = this;
      if (!am.$scrollTarget) return;

      let $scrollTarget = am.$scrollTarget;

      // show progress if scroll required
      am.showScrollProgress =
        $scrollTarget.clientWidth !== $scrollTarget.scrollWidth;

      // update progress percent
      let scrollProgress =
        (($scrollTarget.scrollLeft + $scrollTarget.clientWidth) /
          $scrollTarget.scrollWidth) *
        100;
      am.scrollProgress = scrollProgress.toFixed(2);
    },
  }));

  Alpine.data("LifestyleImages", () => ({
    $slick: null,
    init() {
      let am = this;
      document.addEventListener("init:LifestyleImagesCarousel", (e) => {
        let $target = e.target;
        am.$slick = $target.querySelector(".carousel-lifestyle");

        am.initCarousel();
      });
    },

    initCarousel() {
      let am = this;
      $(am.$slick).slick({
        autoplay: true,
        autoplaySpeed: 0,
        speed: 7500,
        cssEase: "linear",
        adaptiveHeight: true,
        slidesToShow: 2.5,
        infinite: true,
        responsive: [
          {
            breakpoint: 750,
            settings: {
              slidesToShow: 2,
            },
          },
        ],
      });
    },
  }));

  Alpine.data("TabAccordion", () => ({
    tab_open: false,
  }));

  // smooth scroll
  document.addEventListener("smooth-scroll-to", (e) => {
    // console.log(e);
    let $scrollTarget = document.querySelector(e.detail.target);
    if ($scrollTarget) {
      let offset =
        document.querySelector(".announcement-bar").clientHeight +
        document.querySelector(".site-header__mobile-nav").clientHeight;
      window.scrollTo({
        top: $scrollTarget.offsetTop - offset,
        behavior: "smooth",
      });
    }
  });

  // Stick atc
  const IsInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    let stickyOffset =
      document.querySelector(".announcement-bar").clientHeight +
      document.querySelector(".site-header__mobile-nav").clientHeight;

    return (
      rect.top >= 0 &&
      rect.left >= 0 &&
      rect.bottom + stickyOffset <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
  };
  document.addEventListener("init-sticky-atc", (e) => {
    let $stickyForm = e.target;
    let isFormInView = IsInViewport(
      document.querySelector(".product-form__cart-submit")
    );
    $stickyForm.classList.toggle("visible", !isFormInView);

    document.addEventListener("scroll", () => {
      let isFormInView = IsInViewport(
        document.querySelector(".product-form__cart-submit")
      );
      $stickyForm.classList.toggle("visible", !isFormInView);
    });
  });
});

$(document).ready(function () {
  jQuery("a.smooth_scroll_to").click(function () {
    const target = jQuery(this).data("target");
    window.scrollTo({
      top: jQuery(target).offset().top,
      behavior: "smooth",
    });
  });
});

// HEADER
$(document).ready(function () {
  const header = $("#shopify-section-header");
  const headerHeight = header?.outerHeight();
  const pageContainer = $("#PageContainer");

  if (pageContainer) {
    pageContainer.css("padding-top", headerHeight);
  }

  $(".carousel_announcement_bar .callout_slider_wrapper").slick({
    dots: false,
    arrows: true,
    infinite: true,
    speed: 300,
    autoplaySpeed: 5000,
    autoplay: true,
  });

  const $collectionPageMenu = $(".sticky_bar_section_shop");
  const $collectionPageMenuTop = $collectionPageMenu?.offset()?.top;

  let lastScrollTop = 0;
  $(window).scroll(function () {
    const st = $(this).scrollTop();
    if (document.documentElement.classList.contains("mobile_nav_open")) return;

    if (st <= headerHeight) {
      document.documentElement.classList.add("top-of-page");
    } else if (st > lastScrollTop) {
      document.documentElement.classList.remove("top-of-page");
      document.documentElement.classList.remove("scroll-up");
      document.documentElement.classList.add("scroll-down");
    } else {
      document.documentElement.classList.remove("top-of-page");
      document.documentElement.classList.remove("scroll-down");
      document.documentElement.classList.add("scroll-up");
      console.log("scrolling up");
    }

    if ($collectionPageMenuTop) {
      if (st > $collectionPageMenuTop) {
        $collectionPageMenu.addClass("scroll-active");
      } else {
        $collectionPageMenu.removeClass("scroll-active");
      }
    }

    lastScrollTop = st;
  });

  $(window).on("resize", function () {
    const headerHeight = header?.outerHeight();

    if (pageContainer) {
      pageContainer.css("padding-top", headerHeight);
    }
  });
});
